import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <Section background="darker" id="pricing" data-id="element-105">
      <div className="max-w-3xl mx-auto bg-[#1A2A1A] rounded-2xl overflow-hidden border-2 border-[#FF6B00] shadow-[0_0_50px_rgba(255,107,0,0.15)]" data-id="element-106">
        <div className="bg-[#FF6B00] py-3 text-center" data-id="element-107">
          <p className="text-white font-black uppercase tracking-widest text-sm md:text-base animate-pulse" data-id="element-108">
            ⚠️ Oferta disponible solo por tiempo limitado
          </p>
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-109">
          <h2 className="text-2xl md:text-4xl font-bold text-white uppercase mb-2" data-id="element-110">
            TU OPORTUNIDAD DE ORO
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-111">Para transformarte por completo</p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-112">
            <div className="w-48 shrink-0" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/fRW7ZNvQkSY32UYgSSrrCY/bd44924e-min.png" alt="Varamax Pack" className="w-full drop-shadow-2xl" data-id="element-114" />
            </div>

            <div className="text-left" data-id="element-115">
              <p className="text-gray-500 text-lg font-medium mb-1" data-id="element-116">
                Valor Total:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-117">
                  $175.000
                </span>
              </p>
              <div className="flex items-baseline gap-2 mb-2" data-id="element-118">
                <span className="text-gray-300 text-xl font-bold" data-id="element-119">
                  HOY SOLO PAGAS:
                </span>
              </div>
              <p className="text-6xl md:text-7xl font-black text-[#FF6B00] tracking-tighter mb-4" data-id="element-120">
                $17.999
              </p>
              <div className="bg-[#22C55E]/10 border border-[#22C55E]/30 rounded px-3 py-1 inline-block" data-id="element-121">
                <p className="text-[#22C55E] text-sm font-bold" data-id="element-122">
                  Ahorras 90% HOY
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3 mb-10 text-left max-w-md mx-auto" data-id="element-123">
            {['Acceso inmediato al Método Varamax', 'Los 3 Bonos de Regalo ($183 valor)', 'Garantía de 30 días sin preguntas', 'Soporte prioritario por WhatsApp', 'Actualizaciones de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-124">
                <div className="bg-[#22C55E] rounded-full p-0.5" data-id="element-125">
                  <Check size={12} className="text-white" data-id="element-126" />
                </div>
                <span className="text-gray-300" data-id="element-127">{item}</span>
              </div>)}
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-128">
            <Button fullWidth size="xl" className="text-xl md:text-2xl mb-4 animate-shimmer bg-[linear-gradient(110deg,#FF6B00,45%,#FF8F40,55%,#FF6B00)] bg-[length:200%_100%] transition-colors" href="https://tododigitalizado.site/cart/add?id=43131978317958&quantity=1" data-id="element-129">
              ORDENA AHORA Y ACCEDE A LA OFERTA
            </Button>
          </motion.div>

          <p className="text-xs text-gray-500 flex items-center justify-center gap-2" data-id="element-130">
            <AlertTriangle size={12} data-id="element-131" />
            <span data-id="element-132">
              El precio subirá a $49.00 cuando el contador llegue a cero.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}